// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pricing-col {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  margin-top: 30px;\n}\n.pricing-col .pricing-body {\n  background: #3a4a4c;\n  color: #fff;\n  padding-bottom: 0;\n}\n.pricing-col h4 {\n  background: #86b2b8;\n  color: #fff !important;\n  padding: 15px;\n  font-size: 26px;\n}\n.pricing-col p {\n  text-align: left;\n  padding: 5px 10px;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
